import React from 'react';
import {useLocation, useParams} from 'react-router-dom';

import {Loader} from 'components/Loader';
import {SafeHTML} from 'components/news/SafeHTML';
import {VKVideoFrame} from 'components/news/VKVideoFrame';
import {useNewsDetail} from 'hooks/useQuery/news/useNewsDetail';

import './CKEditor.scss';
import styles from './styles.module.scss';

const getPageTitle = (newsItem) => {
    if (!newsItem) {
        return '';
    }

    return newsItem.title || 'Новость';
};

const getItemType = (newsItem) => {
    if (!newsItem) {
        return '';
    }

    return String(newsItem.type || newsItem.contentType || '').toLowerCase();
};

export const NewsDetail = () => {
    const { id } = useParams();
    const location = useLocation();
    const initialNewsItem = location.state && location.state.content ? location.state.content : null;
    const { newsItem, isLoading } = useNewsDetail(id, initialNewsItem);
    const itemType = getItemType(newsItem);

    if (isLoading) {
        return (
            <div className={styles.loaderWrapper}>
                <Loader />
            </div>
        );
    }

    if (!newsItem) {
        return <div className={styles.error}>Не удалось загрузить новость</div>;
    }

    return (
        <div className={styles.contentWrapper}>
            <h1 className={styles.title}>{getPageTitle(newsItem)}</h1>

            {itemType === 'video' && newsItem.iframeInfo ? (
                <VKVideoFrame mb={24} iframeData={newsItem.iframeInfo} />
            ) : null}

            {itemType === 'video' && newsItem.description ? (
                <div>
                    <p className={styles.desc}>Описание</p>
                    <SafeHTML html={newsItem.description} className={styles.contentInnerWrapper} />
                </div>
            ) : null}

            {itemType !== 'video' && newsItem.contentHTML ? (
                <SafeHTML html={newsItem.contentHTML} className={styles.contentInnerWrapper} />
            ) : null}
        </div>
    );
};
